module.exports = __webpack_public_path__ + "img/Sound Decision Maker.46572cc0.svg";